<template>
  <div class="login">
    <div class="login-wrapper">
      <span class="close" @click="hide"><Icon class="icon" type="close" /></span>
      <div class="user"><Icon class="icon" type="user" /><input type="text" v-model="sid" placeholder="输入你的学号"></div>
      <div class="pwd"><Icon class="icon" type="pwd" /><input type="password" v-model="pwd" placeholder="输入身份证后四位"></div>
      <button class="login-btn" @click="login">登录</button>
      <p>如出现信息正确无法登录的情况，请联系管理人员<br>电话：18918183244 为你开通</p>
    </div>
  </div>
</template>

<script>
import Icon from './Icon.vue'
export default {
  data() {
    return {
      sid: '',
      pwd: '',
    }
  },
  components: {
    Icon
  },
  methods: {
    login() {
      this.$store.commit('login', {sid: this.sid, pwd: this.pwd.toUpperCase()})
    },
    hide() {
      this.$store.commit('loginCancel')
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin abs-center {position: absolute; top:0; left: 0; right:0; bottom: 0; margin: auto}
@mixin flex-col-center {display: flex; align-items: center; flex-direction: row;}
.login {
  height: 100vh; width: 100%; background: rgba(0,0,0,0.4); position: absolute; top: 0; left: 0; z-index: 100;
  .login-wrapper {
    padding: 190px 76px 0; width:672px; height:760px; background:rgba(255,255,255,1); 
    box-shadow:0px 8px 32px 0px rgba(0,0,0,0.1); border-radius:8px; overflow: hidden;
    @include abs-center;
    .close{ position: absolute; top: 40px; right: 40px; width: 36px;height: 36px; display: block;
      .icon { width: 100%; height: 100%;}
    }
    .user, .pwd{
      @include flex-col-center();
      height:120px;
      font-size:28px;
      color:rgba(204,204,204,1);
      letter-spacing:1px;
      border-bottom: 2px solid #E5E5E5;
      .icon {
        width: 32px;
        height: 32px;
        color: #666;
      }
      input {
        flex: 1;
        margin-left: 32px;
        border: none;
        outline: none;
        background-color: #fff;
        font-size: 28px;
        &::placeholder{
          color: #ccc;
        }
      }
    }
    .pwd {
      margin-top: 20px;
    }
    p {
      font-size: 22px;
      color: #999;
      line-height: 1.2;
      margin-top: 20px;
    }
    .login-btn {
      display: block;
      margin: 130px auto 0;
      width:240px;
      height:64px;
      background:linear-gradient(134deg,rgba(36,159,217,1) 0%,rgba(26,72,156,1) 100%);
      border-radius:8px;
      line-height: 64px;
      text-align: center;
      font-size:32px;
      color:rgba(255,255,255,1);
      letter-spacing: 1px;
      text-indent: 1px;
    }
  }
  

}
</style>